import React from "react";
import { Box, Grid, makeStyles, createStyles } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import withAuthority from "../../Auth/withAuthority";
import Authorities from "../../../auth/authorities";
import { CustomTheme } from "../../../types/customTheme";

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    container: {
      padding: "24px",
      backgroundColor: theme.palette.background.default,
    },
    headerSection: {
      display: "flex",
      alignItems: "center",
      marginBottom: "24px",
    },
    summaryCard: {
      backgroundColor: theme.palette.background.entity_highlight_background,
      borderRadius: "10px",
      padding: "16px",
      display: "flex",
      alignItems: "center",
      height: "80px",
    },
    productCard: {
      backgroundColor: theme.palette.background.entity_highlight_background,
      borderRadius: "12px",
      padding: "16px",
      height: "140px",
      display: "flex",
      gap: "16px",
    },
  })
);

const TextSkeletonLoading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {/* 1. Category Info Header */}
      <Box className={classes.headerSection}>
        <Skeleton variant="rect" width={40} height={40} style={{ borderRadius: 8, marginRight: 16 }} />
        <Box flex={1}>
          <Skeleton variant="text" width="20%" height={30} />
          <Skeleton variant="text" width="10%" height={20} />
        </Box>
        <Box display="flex" style={{gap: "8px"}}>
            <Skeleton variant="circle" width={32} height={32} />
            <Skeleton variant="circle" width={32} height={32} />
            <Skeleton variant="circle" width={32} height={32} />
        </Box>
      </Box>

      {/* 2. Categody Summary Count Cards (The 4 big blocks) */}
      <Grid container spacing={2} style={{ marginBottom: "32px" }}>
        {[1, 2, 3, 4].map((i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box className={classes.summaryCard}>
              <Skeleton variant="circle" width={44} height={44} style={{ marginRight: 16 }} />
              <Box flex={1}>
                <Skeleton variant="text" width="40%" height={25} />
                <Skeleton variant="text" width="60%" height={15} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* 3. Item Cards Grid */}
      <Grid container spacing={3}>
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Grid item xs={12} md={6} lg={4} key={i}>
            <Box className={classes.productCard}>
              <Skeleton variant="rect" width={100} height="100%" style={{ borderRadius: 8 }} />
              <Box flex={1}>
                <Box display="flex" justifyContent="space-between">
                    <Skeleton variant="text" width="50%" height={25} />
                    <Skeleton variant="rect" width={50} height={20} style={{ borderRadius: 10 }} />
                </Box>
                <Skeleton variant="text" width="30%" height={20} style={{ marginTop: 20 }} />
                <Box display="flex" justifyContent="flex-end" marginTop="auto" style={{gap: "8px"}}>
                    <Skeleton variant="rect" width={24} height={24} />
                    <Skeleton variant="rect" width={24} height={24} />
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default withAuthority(TextSkeletonLoading, Authorities.DASHBOARD_READ);